import initOurRangeElectric from './initOurRangeElectric';

const ourRangeNewVehicles = document.querySelectorAll('.cms-content-our-range')
const ourRangeNewVehiclesLength = ourRangeNewVehicles.length;
if (ourRangeNewVehiclesLength > 0) {
    for (let index = 0; index < ourRangeNewVehiclesLength; index++) {
        initOurRangeElectric(ourRangeNewVehicles[index]);
    }
}